import useJsonApi from "lib/useJsonApi.js";

function useSessionOrderSummaries(sessionUuid) {
  return useJsonApi({
    url: `/api/session/${sessionUuid}/order-summaries`,
  });
}

export default useSessionOrderSummaries;
